import { graphql } from "react-relay";

export const fragments = {
  org: graphql`
    fragment AutopilotSuggestionLessenConstraint_org on Org {
      id
    }
  `,
  lessenAutopilotConstraintKnob: graphql`
    fragment AutopilotSuggestionLessenConstraint_lessenAutopilotConstraintKnob on LessenAutopilotConstraintKnob {
      __typename
      knobUrn {
        id
        type
        value
      }
      externalEventId
      affectedGoals
      knobScore
    }
  `,
  referencedEvents: graphql`
    fragment AutopilotSuggestionLessenConstraint_referencedEvents on Event @relay(plural: true) {
      title
      startTime {
        millis
      }
      endTime {
        millis
      }
      eventKey {
        externalEventId
      }
    }
  `,
};
